import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { type FC, memo, type ReactElement } from 'react';
interface IProps {
  className?: string;
  doteClassName?: string;
  size?: 'small' | 'medium';
}
const DotDividerComponent: FC<IProps> = t0 => {
  const $ = _c(17);
  const {
    className,
    doteClassName,
    size: t1
  } = t0;
  const size = t1 === undefined ? "medium" : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== className || $[1] !== doteClassName || $[2] !== size) {
    const sizeClass = {
      small: "h-1 w-1 2md:h-1.5 2md:w-1.5",
      medium: "h-2 w-2 2md:h-4 2md:w-4"
    };
    if ($[7] !== className || $[8] !== size) {
      const gapClass = {
        small: "gap-2 2md:gap-3",
        medium: "gap-2 2md:gap-[10px]"
      };
      t3 = clsx("flex w-fit items-center px-2 py-1", gapClass[size], className);
      $[7] = className;
      $[8] = size;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t4 = <span className={clsx("block rounded-full bg-white", sizeClass[size], doteClassName)} />;
    t5 = <span className={clsx("block rounded-full bg-white", sizeClass[size], doteClassName)} />;
    t2 = clsx("block rounded-full bg-white", sizeClass[size], doteClassName);
    $[0] = className;
    $[1] = doteClassName;
    $[2] = size;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[10] !== t2) {
    t6 = <span className={t2} />;
    $[10] = t2;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <div className={t3}>{t4}{t5}{t6}</div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
DotDividerComponent.displayName = 'DotDivider';
export const DotDivider = memo(DotDividerComponent);